import React from "react"
import { Button } from "primereact/button"
import { CopilotNotificationProps } from "../../../context/interfacesAndTypes"
import "./CopilotNotification.css"

const CopilotNotification: React.FC<CopilotNotificationProps> = ({
  name,
  expertAnswer,
  requestId,
  handleCloseCopilotNotification,
  handleExpertUpdatedResponseCopilot,
  setExpertAnswerIds,
  expertAnswerIds,
  index,
}) => {
  const handleCopilotResponse = (requestId: string, expertAnswer: string) => {
    handleExpertUpdatedResponseCopilot(requestId, expertAnswer)
    setExpertAnswerIds([...expertAnswerIds, requestId])
  }

  return (
    <div className="copilot-notification-container">
      <div
        className="copilot-notification-header"
        // onClick={() => handleCopilotResponse(requestId, expertAnswer)}
      >
        {/* Click here to see what our expert has to say about your previously
          asked query? */}
        <span className="pi pi-circle-fill blink"></span>
        <h3>Expert responded</h3>
      </div>
      <div className="copilot-notification-content">
        <p
          onClick={() => handleCopilotResponse(requestId, expertAnswer)}
          title="view updated response"
        >
          {/* <span className="text-[#418920] font-medium text-[14px] whitespace-nowrap leading-3">
            {`${name} : `}
          </span>{" "}
          &nbsp; {expertAnswer} */}
          Click here to view response{" "}
          <span
            style={{
              marginLeft: "12px",
              borderRadius: "12px",
              padding: "6px",
              backgroundColor: "#fff",
            }}
          >
            {index + 1}
          </span>
        </p>
        <Button
          title="dismiss this response"
          icon={"pi pi-times"}
          onClick={() => handleCloseCopilotNotification(requestId)}
          className="copilot-notification-dismiss-btn"
        />
      </div>
    </div>
  )
}

export default CopilotNotification
